<template>
  <div id="coral-blog">
      <Header v-if="!loading"/>
      <transition name="component-fade" mode="out-in">
          <router-view/>
      </transition>
  </div>
</template>

<script>
  import Header from "./components/Header.vue";
  export default {
    components: {
      Header
    },
    data() {
      return {
        loading: true
      }
    },
    async mounted() {
      await this.$store.dispatch("GET_TRANSLATIONS");
      this.loading = false;
    },
    watch:{
      $route (){
        if ('refEvent' in window) {
          window.refEvent()
        }
      }
    }
  }
</script>
<style>
    @font-face {
        font-family: 'Bebas Neue';
        src: url('assets/fonts/BebasNeuePro-Bold.woff2') format('woff2');
        font-weight: normal;
        font-style: normal;
        font-display: block;
    }

    @font-face {
        font-family: 'Roboto Medium';
        src: url('assets/fonts/RobotoMedium.woff2') format('woff2');
        font-weight: normal;
        font-style: normal;
    }

    #coral-blog {
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        color: #252631;
    }

    #coral-blog a {
        text-decoration: none;
        color: inherit;
    }

    img, svg {
        display: initial !important;
        vertical-align: initial !important;
    }

    /* Transitions */

    .component-fade-enter-active {
        transition: opacity .3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .1s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
    {
        opacity: 0;
    }

    .productButtonLink,
    a.productButtonLink {
      height: 40px;
      background: #fa5f55;
      font-size: 12px;
      font-weight: 700;
      line-height: 38px;
      letter-spacing: .58px;
      padding: 0 calc(10px + (20 - 10) *(100vw - 575px)/ (1920 - 575));
      color: #fff !important;
      text-transform: uppercase;
      max-width: 100%;
      text-align: center;
    }

    a.productButtonLink.is-big {
      font-size: 20px;
      padding: 16px 32px;
      min-width: 120px;
      line-height: normal;
      height: auto;
    }


</style>
